export default {
    name: "log-query",
    data() {
        return {
            sites: [],
            selectedSiteId: 0,
            selectedSite: null,
            name: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            emailAddress: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            mobileNumber: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            cardBarcodeNumber: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            message: {
                value: null,
                hasError: false,
                errorMessage: null
            },
            submissionSuccess: false,
            loading: false
        };
    },
    methods: {
        getSites(){
            systemService.getSites().then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if(isSuccess){
                        //success
                        console.log("success", successResponse);
                        this.sites = successResponse.data.result;
                        this.sites = $.map(this.sites,
                            function (obj) {
                                obj.id = obj.id || obj.siteId;
                                obj.text = obj.text || obj.name;
                                return obj;
                            });
                        if(this.sites !== null && this.sites !== undefined && this.sites.length > 0){
                            this.selectedSiteId = this.sites[0].id;
                            this.selectedSite = this.sites[0].text;
                        }
                    }
                },
                errorResponse => {
                    //error
                    console.log("error", errorResponse);
                    //apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        sendLogQuery() {
            this.loading = true;
            this.submissionSuccess = false;
            let request = {
                site: this.selectedSite,
                name: this.name.value,
                email: this.emailAddress.value,
                mobileNumber: this.mobileNumber.value,
                cardBarcodeNumber: this.cardBarcodeNumber.value,
                message: this.message.value
            };
            notificationService.sendQueryEmail(request).then(
                response => {
                    if(response.status === 400){
                        this.name.hasError = response.data.logQueryValidationResponse.nameValidationResponse.hasError;
                        this.name.errorMessage = response.data.logQueryValidationResponse.nameValidationResponse.message;
                        
                        this.emailAddress.hasError = response.data.logQueryValidationResponse.emailValidationResponse.hasError;
                        this.emailAddress.errorMessage = response.data.logQueryValidationResponse.emailValidationResponse.message;
                        
                        this.mobileNumber.hasError = response.data.logQueryValidationResponse.mobileNumberValidationResponse.hasError;
                        this.mobileNumber.errorMessage = response.data.logQueryValidationResponse.mobileNumberValidationResponse.message;
                        
                        this.message.hasError = response.data.logQueryValidationResponse.messageValidationResponse.hasError;
                        this.message.errorMessage = response.data.logQueryValidationResponse.messageValidationResponse.message;
                    }
                    if(response.status === 200){
                        this.submissionSuccess = true;
                        this.clearModels();
                    }
                    this.loading = false;
                });
        },
        onSiteDropdownChange(site){
            console.log("Site dropdown change");
            console.log(site);
            this.selectedSiteId = site.id;
            this.selectedSite = site.text;
        },
        clearModels(){
            this.name = {
                value: null,
                hasError: false,
                errorMessage: null
            };
            this.emailAddress = {
                value: null,
                hasError: false,
                errorMessage: null
            };
            this.mobileNumber = {
                value: null,
                hasError: false,
                errorMessage: null
            };
            this.cardBarcodeNumber = {
                value: null,
                hasError: false,
                errorMessage: null
            };
            this.message = {
                value: null,
                hasError: false, 
                errorMessage: null
            };
        }
    },
    mounted: function () {
        this.getSites();
    }
};